import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ITEM_ATA.BUSCAR_ITENS_ATA_LISTAGEM]({ state }) {
		const { filtro, paginacao } = state
		const { data } = await api.itemAta.buscarListagem(filtro, paginacao)
		return data
	},

	async [actionTypes.ITEM_ATA.EXCLUIR]({ getters }) {
		const { itensParaExcluir } = getters
		await api.itemAta.excluir(itensParaExcluir)
	},

	async [actionTypes.ITEM_ATA.INSERIR_ITEM_ATA_COM_PROCESSO](context, payload) {
		await api.itemAta.inserirComProcesso(payload)
	},

	async [actionTypes.ITEM_ATA.BUSCAR_ACESSO_HISTORICO_BOTOES](context, idItemAta) {
		return await api.itemAta.buscarAcessoHistoricoBotoes(idItemAta)
	},

	async [actionTypes.ITEM_ATA.SALVAR_INFORMACOES_PRAZO_ENTREGA](context, payload) {
		return await api.itemAta.salvarInformacoesPrazoEntrega(payload)
	},
}
